import type { IconProps } from './types';

export const ArrowNarrowDownIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path d="M12 0.75V21.8437" stroke={color} strokeWidth="1.5" />
      <path d="M4.5 14.3438L12 21.8438L19.5 14.3438" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
